<div id="order-header">
  <mat-table
    id="order-details-modal-timeslot"
    class="table table-striped carrier-overview-table mat-table-modal"
    [dataSource]="orderDatasource"
    matSort
  >
    <!-- loading layout replaced by app after startup -->
    <div class="app-loading">
      <div class="logo"></div>
      <svg class="spinner" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>

    <div class="row">
      <ng-container
        *ngIf="!this.showFreightExchangeDetails"
        matColumnDef="status"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header medium-size-column single-row-column"
        >
          {{ 'ORDER-TABLE.HEADER-STATUS' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="medium-size-column single-row-column"
        >
          {{ element.statusName }}
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="orderId"
        *ngIf="!this.showFreightExchangeDetails"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header medium-size-column single-row-column"
        >
          {{ 'ORDER-TABLE.HEADER-ORDER' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="medium-size-column single-row-column"
        >
          {{ element?.orderId || '-' }}
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="
          showBothLoadingAndDeliveryDetails() &&
          !this.showFreightExchangeDetails
        "
        matColumnDef="loading&delivPl"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header xxl-size-column d-flex flex-row"
        >
          <span class="basis-100">
            {{ 'ORDER-TABLE.HEADER-LOADING' | translate }}
            {{ 'ORDER-TABLE.HEADER-PLACE' | translate }}
          </span>
          <em>{{ 'ORDER-TABLE.HEADER-DELIVERYPLACE' | translate }}</em>
        </mat-header-cell>
        <mat-cell
          #loadingDeliveryPlaceTooltip="matTooltip"
          class="xxl-size-column d-flex flex-row"
          *matCellDef="let element"
          [matTooltipTouchGestures]="'on'"
          matTooltip="{{ getLoadingDeliveryPlace(element) }}"
          [matTooltipPosition]="tooltipPosition"
          (click)="toggleTooltip(loadingDeliveryPlaceTooltip)"
        >
          <span class="trim-text basis-100"
            >{{ element.loadingPl ? element.loadingPl : '-' }} </span
          ><em class="trim-text">
            {{ element.delivPl ? element.delivPl : '-' }}</em
          >
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="showOnlyLoadingDetails()" matColumnDef="loadingPl">
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          {{ 'ORDER-TABLE.HEADER-LOADING' | translate }}
          {{ 'ORDER-TABLE.HEADER-PLACE' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.loadingPl ? this.formatMobile(element.loadingPl) : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="showOnlyDeliveryDetails()" matColumnDef="delivPl">
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          {{ 'ORDER-TABLE.HEADER-DELIVERYPLACE' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.delivPl ? this.formatMobile(element.delivPl) : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="showBothLoadingAndDeliveryDetails()"
        matColumnDef="loading&deliveryDate"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header d-flex flex-row"
        >
          <span class="basis-100"
            ><span class="hide-desktop-height-1">{{
              'ORDER-TABLE.HEADER-LOADING' | translate
            }}</span>
            {{ 'ORDER-TABLE.HEADER-DATETIME' | translate }}
          </span>
          <span class="hide-desktop-height-1"
            ><em>{{
              'ORDER-TABLE.HEADER-DELIVERYDATETIME' | translate
            }}</em></span
          >
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          title="{{ element.loadingDate ? element.loadingDate : '-' }} /
                          {{ element.delivDate ? element.delivDate : '-' }}"
          class="d-flex flex-row"
        >
          <span class="basis-100">
            {{
              element.loadingDate
                ? CommonUtils.combineAndFormatDateTimes(
                    element.loadingDate,
                    element.maxLoadingDateTime
                  )
                : '-'
            }}
          </span>
          <em>{{
            element.delivDate
              ? CommonUtils.combineAndFormatDateTimes(
                  element.delivDate,
                  element.maxDeliveryDateTime
                )
              : '-'
          }}</em>
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="showOnlyLoadingDetails()" matColumnDef="loadingDate">
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          {{ 'ORDER-TABLE.HEADER-LOADING' | translate }}
          {{ 'ORDER-TABLE.HEADER-DATETIME' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="double-mat-cell">
          {{
            element?.loadingDate
              ? CommonUtils.combineAndFormatDateTimes(
                  element.loadingDate,
                  element.maxLoadingDateTime
                )
              : '-'
          }}
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="showOnlyDeliveryDetails()"
        matColumnDef="deliveryDate"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          <em>{{ 'ORDER-TABLE.HEADER-DELIVERYDATETIME' | translate }}</em>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="double-mat-cell">
          <em>{{
            element?.delivDate
              ? CommonUtils.combineAndFormatDateTimes(
                  element.delivDate,
                  element.maxDeliveryDateTime
                )
              : '-'
          }}</em>
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="showFreightExchangeDetails"
        matColumnDef="loadingPostalCodeCountry"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          <span>
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-LOADING' | translate }}
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-PLACE' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell
          [matTooltipTouchGestures]="'on'"
          [matTooltipPosition]="tooltipPosition"
          matTooltipClass="bid-tooltip"
          matTooltip="{{
            element.loadingPostalCodeCountry.length !==
            this.formatPlaceText(element.loadingPostalCodeCountry).length
              ? element.loadingPostalCodeCountry
              : null
          }}"
          *matCellDef="let element"
          #loadingPostalCodeTooltip="matTooltip"
          class="double-mat-cell"
          (click)="toggleTooltip(loadingPostalCodeTooltip)"
        >
          <span>
            <span class="trim-text">{{
              this.formatPlaceText(element.loadingPostalCodeCountry)
            }}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="showFreightExchangeDetails"
        matColumnDef="deliveryPostalCodeCountry"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          <span>
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-DELIVERY' | translate }}
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-PLACE' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="double-mat-cell"
          [matTooltipTouchGestures]="'on'"
          [matTooltipPosition]="tooltipPosition"
          matTooltipClass="bid-tooltip"
          matTooltip="{{
            element.deliveryPostalCodeCountry.length !==
            this.formatPlaceText(element.deliveryPostalCodeCountry).length
              ? element.deliveryPostalCodeCountry
              : null
          }}"
          (click)="toggleTooltip(deliveryPostalCodeCountryTooltip)"
          #deliveryPostalCodeCountryTooltip="matTooltip"
        >
          <span>
            <span class="trim-text">
              {{
                this.formatPlaceText(element.deliveryPostalCodeCountry)
              }}</span
            >
          </span>
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="showFreightExchangeDetails"
        matColumnDef="loadingDate"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          <span>
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-LOADING' | translate }}
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-DATETIME' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="double-mat-cell">
          {{
            element?.loadingDate
              ? CommonUtils.combineAndFormatDateTimes(
                  element.loadingDate,
                  element.maxLoadingDateTime
                )
              : '-'
          }}
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="showFreightExchangeDetails"
        matColumnDef="deliveryDate"
      >
        <mat-header-cell
          *matHeaderCellDef
          mat-header-cell
          class="mat-table-header"
        >
          <span>
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-DELIVERY' | translate }}
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-DATETIME' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="double-mat-cell">
          <span>{{
            element?.delivDate
              ? CommonUtils.combineAndFormatDateTimes(
                  element.delivDate,
                  element.maxDeliveryDateTime
                )
              : '-'
          }}</span>
        </mat-cell>
      </ng-container>
      <ng-container
        matColumnDef="product"
        *ngIf="!this.showFreightExchangeDetails"
      >
        <mat-header-cell
          mat-header-cell
          *matHeaderCellDef
          class="large-size-column mat-table-header d-flex flex-row"
        >
          <span class="basis-100"
            >{{ 'ORDER-TABLE.HEADER-PRODUCT' | translate }}
          </span>
          <em>{{ 'ORDER-TABLE.HEADER-WEIGHT' | translate }}</em>
        </mat-header-cell>
        <mat-cell
          #productTooltip="matTooltip"
          class="large-size-column d-flex flex-row"
          *matCellDef="let element"
          [matTooltipTouchGestures]="'on'"
          [matTooltipPosition]="tooltipPosition"
          matTooltip="{{ getProduct(element.product) }}"
          (click)="toggleTooltip(productTooltip)"
        >
          <span class="trim-text basis-100"
            >{{ element?.product || '-' }}
          </span>
          <em class="trim-text">{{ element?.productDetail | number }} kg</em>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="product"
        *ngIf="this.showFreightExchangeDetails"
      >
        <mat-header-cell
          mat-header-cell
          *matHeaderCellDef
          class="large-size-column mat-table-header d-flex flex-row"
        >
          <span class="basis-100">
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-PRODUCT' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell
          #productTooltip="matTooltip"
          class="large-size-column d-flex flex-row"
          *matCellDef="let element"
          [matTooltipPosition]="tooltipPosition"
          matTooltipClass="bid-tooltip"
          [matTooltipTouchGestures]="'on'"
          matTooltip="{{ getProduct(element.product) }}"
          (click)="toggleTooltip(productTooltip)"
        >
          <span class="trim-text basis-100"
            >{{ element?.product || '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="quantity"
        *ngIf="this.showFreightExchangeDetails"
      >
        <mat-header-cell
          mat-header-cell
          *matHeaderCellDef
          class="large-size-column mat-table-header d-flex flex-row"
        >
          <span class="basis-100">
            {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-QUANTITY' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell
          class="large-size-column d-flex flex-row"
          *matCellDef="let element"
        >
          <span class="trim-text basis-100"
            >{{ element?.productDetail | number }} kg
          </span>
        </mat-cell>
      </ng-container>

      <ng-container
        matColumnDef="salesNr"
        *ngIf="!this.showFreightExchangeDetails"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header extra-large-size-column d-flex flex-row"
        >
          <span class="basis-100"
            >{{ 'ORDER-TABLE.HEADER-SALESNR' | translate }}
          </span>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="extra-large-size-column d-flex flex-row"
        >
          <span class="basis-100">{{ element?.salesNr || '-' }} </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="reference">
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="large-size-column mat-table-header d-flex flex-row"
        >
          <span class="basis-100">{{
            'ORDER-TABLE.HEADER-LOADING-REF' | translate
          }}</span>
          <em>{{ 'ORDER-TABLE.HEADER-DELIVERY-REF' | translate }}</em>
        </mat-header-cell>
        <mat-cell
          #loadingDeliveryRefTooltip="matTooltip"
          class="large-size-column d-flex flex-row"
          *matCellDef="let element"
          [matTooltipTouchGestures]="'on'"
          [matTooltipPosition]="tooltipPosition"
          matTooltip="{{ getLoadingDeliveryRef(element) }}"
          (click)="toggleTooltip(loadingDeliveryRefTooltip)"
        >
          <span class="trim-text basis-100"
            >{{ element.loadingReference ? element.loadingReference : '-' }}
          </span>
          <em class="trim-text">{{
            element.deliveryReference ? element.deliveryReference : '-'
          }}</em>
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="this.enableBookingFunction"
        matColumnDef="loading&delivTS"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header extra-large-size-column"
        >
          {{ 'ORDER-TABLE.HEADER-TIMESLOT' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="extra-large-size-column">
          <div class="row timeslot-booking-buttons">
            <div
              [ngClass]="
                this.isMobile ? 'col-2 ml-3 px-2' : 'col-5 align-self-center'
              "
              class="loading-container"
            >
              <button
                type="button"
                id="btnLoadingDetails"
                class="loading-button mobile-button btn btn-sm btn-primary primary-btn-theme"
                *ngIf="
                  element.loadingTimeslotRequired && !element.loadingTs;
                  else showLoadingTimeslot
                "
                (click)="openLoadingTimeslotBooking()"
              >
                <span class="orders-button-txt text-center">
                  {{ 'ORDER-LIST-DETAILS.TIMESLOT-LOADING-BUTTON' | translate }}
                </span>
              </button>
              <ng-template #showLoadingTimeslot>
                <span
                  [class.hidden]="!element.loadingTs"
                  class="interaction timeslot-booked-button raised-primary hide-mobile hide-tablet-portrait hide-tablet-landscape"
                  (click)="openLoadingTimeslotBooking()"
                >
                  {{ element.loadingTs }}
                </span>
                <button
                  type="button"
                  [class.hidden]="!element.loadingTs"
                  id="btnLoadingDetails"
                  class="loading-button hide-desktop mobile-button btn btn-sm btn-primary primary-btn-theme"
                  (click)="openLoadingTimeslotBooking()"
                >
                  <span class="orders-button-txt text-center">
                    {{ element.loadingTs }}
                  </span>
                </button>
              </ng-template>
            </div>
            <div
              [ngClass]="
                this.isMobile ? 'col-2 ml-3 px-2' : 'col-5 align-self-center'
              "
              class="delivery-container"
            >
              <button
                type="button"
                id="btnLeliveryDetails"
                class="delivery-button mobile-button btn btn-sm btn-primary primary-btn-theme"
                *ngIf="
                  element.deliveryTimeslotRequired && !element.deliveryTs;
                  else showDeliveryTimeslot
                "
                (click)="openDeliveryTimeslotBooking()"
              >
                <span class="orders-button-txt text-center">
                  {{
                    'ORDER-LIST-DETAILS.TIMESLOT-DELIVERY-BUTTON' | translate
                  }}
                </span>
              </button>
              <ng-template #showDeliveryTimeslot>
                <span
                  [class.hidden]="!element.deliveryTs"
                  class="interaction timeslot-booked-button raised-primary hide-mobile hide-tablet-portrait hide-tablet-landscape"
                  (click)="openDeliveryTimeslotBooking()"
                >
                  {{ element.deliveryTs }}
                </span>
                <button
                  type="button"
                  id="btnLeliveryDetails"
                  [class.hidden]="!element.deliveryTs"
                  class="delivery-button hide-desktop mobile-button btn btn-sm btn-primary primary-btn-theme"
                  (click)="openDeliveryTimeslotBooking()"
                >
                  <span class="orders-button-txt text-center">
                    {{ element.deliveryTs }}
                  </span>
                </button>
              </ng-template>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container
        *ngIf="this.enableAcceptRejectFunction"
        matColumnDef="acceptReject"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header hide-mobile hide-tablet-portrait hide-tablet-landscape order-acceptance"
        >
          {{ 'ORDER-TABLE.HEADER-ORDERACCEPTANCE' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="hide-mobile hide-tablet-portrait hide-tablet-landscape order-acceptance d-flex justify-between items-center"
        >
          <button
            *ngIf="orderCanBeAcceptedOrRejected()"
            type="button"
            id="btnAccept"
            class="btn btn-sm btn-success accept-button"
            [disabled]="isImpersonated"
            (click)="confirmAcceptOrder()"
          >
            <span class="orders-button-txt">{{
              'SHARED.BUTTON-ACCEPT' | translate
            }}</span>
          </button>
          <button
            *ngIf="orderCanBeAcceptedOrRejected()"
            type="button"
            id="btnReject"
            [disabled]="isImpersonated"
            (click)="confirmRejectOrder()"
            class="btn btn-sm btn-danger decline-button"
          >
            <span class="orders-button-txt">{{
              'SHARED.BUTTON-DECLINE' | translate
            }}</span>
          </button>
          <ng-container
            *ngIf="orderIsRejected(element) && !!element.rejectedByDetails"
          >
            <span
              >{{ 'ORDER-TABLE.REJECTED-BY' | translate }}
              {{ element.rejectedByDetails?.rejectedBy }}<br />{{
                'ORDER-TABLE.AT' | translate
              }}
              {{
                CommonUtils.formatDateTime(
                  element.rejectedByDetails?.rejectedTime
                )
              }}</span
            >
          </ng-container>
        </mat-cell>
      </ng-container>
      <ng-container
        *ngIf="this.showFreightExchangeDetails"
        matColumnDef="targetPrice"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header extra-large-size-column single-row-column"
        >
          {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-TARGET-PRICE' | translate }}
        </mat-header-cell>
        <mat-cell
          class="extra-large-size-column single-row-column"
          *matCellDef="let element"
        >
          <span
            *ngIf="
              !element.targetPrice || element.targetPrice === 0;
              else targetPriceNumber
            "
          >
            -
          </span>
          <ng-template #targetPriceNumber>
            {{ element.targetPrice | number }} {{ orderCurrencySymbol }}
          </ng-template>
        </mat-cell>
      </ng-container>
      <ng-container
        *ngIf="this.showFreightExchangeDetails"
        matColumnDef="bidPrice"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header extra-large-size-column single-row-column"
        >
          {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-BID-PRICE' | translate }}
        </mat-header-cell>
        <mat-cell
          class="extra-large-size-column single-row-column"
          *matCellDef="let element"
        >
          <span *ngIf="!!element.bidPrice && element.bidPrice > 0">
            {{ element.bidPrice | number }} {{ orderCurrencySymbol }}</span
          >
          <span *ngIf="!element.bidPrice || element.bidPrice === 0"> - </span>
        </mat-cell>
      </ng-container>
      <ng-container
        *ngIf="this.showFreightExchangeDetails"
        matColumnDef="productGrade"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header extra-large-size-column single-row-column"
        >
          {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-PRODUCT-GRADE' | translate }}
        </mat-header-cell>
        <mat-cell
          class="extra-large-size-column single-row-column"
          *matCellDef="let element"
        >
          <span class="trim-text">{{
            formatProductGrade(element.productGrade) | translate
          }}</span>
        </mat-cell>
      </ng-container>
      <ng-container
        *ngIf="this.showFreightExchangeDetails"
        matColumnDef="productType"
      >
        <mat-header-cell
          scope="col"
          mat-header-cell
          *matHeaderCellDef
          class="mat-table-header extra-large-size-column single-row-column"
        >
          {{ 'FREIGHT-EXCHANGE-TABLE.HEADER-PRODUCT-TYPE' | translate }}
        </mat-header-cell>
        <mat-cell
          class="extra-large-size-column single-row-column"
          *matCellDef="let element"
          #productTypeTooltip="matTooltip"
          [matTooltipTouchGestures]="'on'"
          [matTooltipPosition]="tooltipPosition"
          matTooltipClass="bid-tooltip"
          matTooltip="{{ getProductType(element.productType) }}"
          (click)="toggleTooltip(productTypeTooltip)"
        >
          <span class="trim-text">{{ element.productType }}</span>
        </mat-cell>
      </ng-container>
    </div>

    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay"> </mat-row>
  </mat-table>
</div>
